// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__fdHQl","content":"Page_content__cRlwi","withSidePadding":"Page_withSidePadding__Uda5E"};